import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center xl:justify-center gap-y-4 fixed h-max bottom-0 mt-auto xl:right-[2%] z-50 top-0 w-full xl:w-16 xl:max-w-md xl:h-screen" }
const _hoisted_2 = { class: "flex w-full xl:flex-col items-center justify-between xl:justify-center gap-y-10 px-4 md:px-40 xl:px-0 h-[80px] xl:h-max bottom-0 py-8 bg-white/10 backdrop-blur-sm text-3xl xl:text-xl xl:rounded-full" }
const _hoisted_3 = { class: "absolute pr-14 right-0 hidden xl:group-hover:flex" }
const _hoisted_4 = { class: "bg-white relative flex text-primary items-center p-[6px] rounded-[3px]" }
const _hoisted_5 = { class: "text-[12px] leading-0 font-semibold capitalize" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "border-solid border-l-white border-l-8 border-y-transparent border-y-[6px] border-r-0 absolute -right-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Links(), (link, index) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.pageLoadingStore.isLoading ? 'button' : 'router-link'), {
          to: _ctx.pageLoadingStore.isLoading ? undefined : link.path,
          class: _normalizeClass(`${
          link.name === 'home' && 'text-accent'
        } relative flex items-center group hover:text-accent transition-all duration-300`),
          key: index
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(link.name), 1),
                _hoisted_6
              ])
            ]),
            (_openBlock(), _createBlock(_resolveDynamicComponent(link.icon), { class: "text-white" }))
          ]),
          _: 2
        }, 1032, ["to", "class"]))
      }), 128))
    ])
  ]))
}